<div class="container">
         <div class="modal-header">
         <h4 class="modal-title">Keep Playlist</h4>
         </div>
        <div class="modal-body">
        <h5>{{message}}</h5>
        </div>
        <div class="modal-footer">
        <button class="btn btn-no" type="button" (click)="decline()">No</button>
        <button class="btn btn-yes" type="submit" (click)="confirm()" >
            Yes,Keep
        </button>
        </div>
</div>